
// @ts-nocheck


export const localeCodes =  [
  "en",
  "zh",
  "ja"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46js_c36fdc4f",
      load: () => import("#nuxt-i18n/c36fdc4f" /* webpackChunkName: "locale_en_46js_c36fdc4f" */),
      cache: false
    }
  ],
  zh: [
    {
      key: "locale_zh_46js_e524500f",
      load: () => import("#nuxt-i18n/e524500f" /* webpackChunkName: "locale_zh_46js_e524500f" */),
      cache: false
    }
  ],
  ja: [
    {
      key: "locale_ja_46js_7a00b05c",
      load: () => import("#nuxt-i18n/7a00b05c" /* webpackChunkName: "locale_ja_46js_7a00b05c" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      name: "ENGLISH",
      files: [
        {
          path: "/codebuild/output/src1852518591/src/i18n/locales/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "zh",
      language: "zh-CN",
      name: "中文",
      files: [
        {
          path: "/codebuild/output/src1852518591/src/i18n/locales/zh.js",
          cache: undefined
        }
      ]
    },
    {
      code: "ja",
      language: "ja-JP",
      name: "日本語",
      files: [
        {
          path: "/codebuild/output/src1852518591/src/i18n/locales/ja.js",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    name: "ENGLISH",
    files: [
      {
        path: "/codebuild/output/src1852518591/src/i18n/locales/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    language: "zh-CN",
    name: "中文",
    files: [
      {
        path: "/codebuild/output/src1852518591/src/i18n/locales/zh.js",
        cache: undefined
      }
    ]
  },
  {
    code: "ja",
    language: "ja-JP",
    name: "日本語",
    files: [
      {
        path: "/codebuild/output/src1852518591/src/i18n/locales/ja.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/